export default {
    namespaced: true,

    state() {
        return {
            learnHowPaymentPlan: null,
            learnHowDrawerVisible: false
        }
    },

    mutations: {
        updateLearnHowPaymentPlan(state, paymentPlan) {
            state.learnHowPaymentPlan = paymentPlan
        },

        updateLearnHowDrawerVisible(state, visible) {
            state.learnHowDrawerVisible = visible
        }
    }
}
